import moment from "moment";

export const getAllowedPeriodOrder = (displayCurrentLessons, displayPrevLessons, displayExams) => {

    const numberOfPeriods = displayCurrentLessons + displayPrevLessons + displayExams;
    return [
        {
            order: {lessons: 1, exams: 2},
            shouldApply: numberOfPeriods === 2 && !displayPrevLessons
        },
        {
            order: {previousLessons: 1, exams: 2, lessons: 3},
            shouldApply: numberOfPeriods === 3
        },
        {
            order: {previousLessons: 1, exams: 2},
            shouldApply: numberOfPeriods === 2 && !displayCurrentLessons
        }
    ];
}

export const getPeriodLabels = (currentTermLessons, previousTermLessons) => [
    {
        key: 'exams',
        label: 'Сессия'
    },
    {
        key: 'lessons',
        label: currentTermLessons?.term ?? 'Занятия'
    },
    {
        key: 'previousLessons',
        label: previousTermLessons?.term ?? 'Занятия'
    }
];

export const getDateOfWeekdayOptions = (filterSelection, startOfTermDate, isCurrentPeriod) => {

    const getShouldShowFirstStudyWeek = () => {
        if (!startOfTermDate || !moment().isBefore(startOfTermDate, 'day')) {
            return false;
        }
        return filterSelection.onlyDefaultWeekSelected;
    }
    return [
        {
            shouldApply: getShouldShowFirstStudyWeek() && isCurrentPeriod !== false,
            getDate: (weekDay) => moment(startOfTermDate).isoWeekday(weekDay),
            shouldDisplayDayLessons: (weekDay) => {
                return !moment(startOfTermDate).isoWeekday(weekDay).isBefore(startOfTermDate);
            }
        },
        {
            shouldApply: moment().isoWeekday() === 7
                && filterSelection.onlyDefaultWeekSelected 
                && isCurrentPeriod !== false,
            getDate: (weekDay) => {
                const nextWeekDate = moment().add(7, 'day');
                return nextWeekDate.isoWeekday(weekDay);
            },
            shouldDisplayDayLessons: (_weekDay) => true
        },
        {
            shouldApply: filterSelection.onlyCurrentWeekSelected && isCurrentPeriod !== false,
            getDate: (weekDay) => moment().isoWeekday(weekDay),
            shouldDisplayDayLessons: (weekDay) => {
                return !moment().isoWeekday(weekDay).isBefore(startOfTermDate);
            }
        }
    ];
}

export const getDefaultPeriodTab = (currentPeriod) => {
    return currentPeriod === 'Сессия' ? 'exams' : 'lessons';
}

export const getDateLabel = (currentDay) => {
    const today = moment().startOf('day');
    let label = '';
    if (currentDay.isSame(today, 'day')) {
        label = '(сегодня), ';
    } else if (currentDay.diff(today, 'days') === 1) {
        label = '(завтра), ';
    }
    return `${label}${currentDay.format('DD.MM')}`;
}